import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { addEmails } from './AdminClient';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledMultilineInput from 'Components/Form/LabelledMultilineInput';
import Error from 'Components/Form/Error';

function AddEmails ()
{
    const { currentUser } = useContext ( CurrentUserContext );

    const [ emails, setEmails ] = useState ( null );
    const [ emailArray, setEmailArray ] = useState ( null );
    
    const [ isSubmitting, setIsSubmitting ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const navigate = useNavigate ();
    
    const doSubmit = async () =>
    {
        if ( isSubmitting === false && emailArray !== null && emailArray.length > 0 )
        {
            setIsSubmitting ( true );

            addEmails ( currentUser, emailArray )
                .then ( response => {
                    alert ( response.data.message );
                    navigate ( "/admin" );
                } )
                .catch ( error => {
                    setIsSubmitting ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }
    }

    const updateEmails = ( newValue ) =>
    {
        let newEmails = newValue.split ( /[\n,]+/ ).map ( email => email.trim ().toLowerCase () ).filter ( email => email.length > 0 );

        setEmails ( newValue );
        setEmailArray ( newEmails );
    }

    return <>
                <h1>Add Emails</h1>
                { error.isError && <Error message={error.message} /> }
                <LabelledMultilineInput label="Enter the emails to add either comma separated or one per line." id="add-emails" value={emails} onChange={ ( newValue ) => updateEmails ( newValue ) } editable={true} />
                <div className="flex flex-row gap-4">
                    <button disabled={isSubmitting} onClick={ () => doSubmit () }>Submit</button>
                    <button disabled={isSubmitting}  onClick={ () => navigate ( "/admin" ) }>Back</button>
                </div>
            </>
}

export default AddEmails;